export const SEARCH_SOURCES = [
  {
    name: 'All resources',
    value: '',
    id: 'search.sources.all'
  },
  {
    name: 'Facebook',
    value: 'facebook.com',
    id: 'search.sources.facebook'
  },
  {
    name: 'Twitter',
    value: 'twitter.com',
    id: 'search.sources.twitter'
  },
  {
    name: 'News',
    value: 'news',
    id: 'search.sources.news'
  },
  {
    name: 'Videos',
    value: 'videos',
    id: 'search.sources.videos'
  },
  {
    name: 'Books',
    value: 'books',
    id: 'search.sources.books'
  },
  {
    name: 'Scholar',
    value: 'scholar',
    id: 'search.sources.scholar'
  },
  {
    name: 'Medicine',
    value: 'ncbi.nlm.nih.gov',
    id: 'search.sources.medicine'
  },
  {
    name: 'Patents',
    value: 'patents',
    id: 'search.sources.patents'
  }
];



// WEBPACK FOOTER //
// ./src/common/constants/searchSources.js